import React from 'react'
import { useFormik } from 'formik'
import * as Yup from 'yup';
import { Button, TextField } from '@mui/material';
import './emailLogin.css';
import { useHistory } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import { useTheme } from '@mui/material/styles';
import { toast } from "react-toastify";
import firebase from "firebase/app";
import { Box } from '@mui/system';

const EmailLogin = ({ handleEmailLogin }) => {
    const history = useHistory();
    const { t, i18n } = useTranslation();
    const theme = useTheme();
    const handleLoginAsGuest = () => {
        console.log("pressed")
        firebase
          .auth()
          .signInAnonymously()
          .then((result) => {
            console.log("from login");
            toast.success(`Wow! \n\n Welcome To WhizzAround!`, {onClose:()=>  history.push("/")});
          })
          .catch((err) => {
            console.log("error : ",err);
            toast.error(`Oops! \n\n Are your sure about your credentials ?`);
          });
      };
    const formik = useFormik({
        initialValues: {
            email: '',
            password: ''
        },
        validationSchema: Yup.object({
            email: Yup.string().required('Email is required').email('Please enter a valid email'),
            password: Yup.string().required('Password is required').min(8, 'Password must be at least 8 characters')
        }),
        onSubmit: (values) => {
            handleEmailLogin(values);
        }
    })
    return (
        <div className='formContainer' style={{marginTop:-50}}>
            <TextField
                id="outlined-email"
                label="Email"
                variant="outlined"
                type={'email'}
                className='formInput'
                name="email"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.email}
                helperText={formik.errors.email}
                error={!!formik.errors.email}
            />
            <TextField
                id="outlined-password"
                label="Password"
                type={'password'}
                variant="outlined"
                className='formInput'
                name="password"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.password}
                helperText={formik.errors.password}
                error={!!formik.errors.password}
            />
            
            <Button className='submitBtn' onClick={formik.handleSubmit} disabled={!formik.isValid} variant="contained" style={{marginTop:"-25px"}}>{t("users.login")}</Button>
            <Button className='submitBtn' onClick={()=>handleLoginAsGuest()} variant="contained" style={{backgroundColor:'#774e1e',marginTop:"-25px"}}>{t("users.loginAsGuest")}</Button>
            {/* <div style={{ display: 'flex', justifyContent:"center",marginTop:"15px"}}>
                <a  onClick={() => {history.push('/phoneLogin') }}>{t("users.loginAsGuest")}</a>
            </div> */}
            <div style={{ display: 'flex', justifyContent:"center",marginTop:"15px"}}>
                <a  onClick={() => {history.push('/phoneLogin') }}>Login or Sign up with phone number</a>
            </div>
        </div>
    )
}

export default EmailLogin